export enum DependentRelationship {
    SPOUSE = 'Spouse',
    CHILD = 'Child'
}